<template>
	<div class="ig-daterange">
		<div class="date-dropdown">
			<div v-if="isOld" style="display: flex; justify-content: baseline">
				<skydropdown-select
					:options="options"
					@change="changeSelect"
					:value="selfData"
				></skydropdown-select>
				<div class="date-range">
					{{ dateRanges }}
				</div>
			</div>
			<!-- 默认是过去7天 -->
			<div v-else>
				<span v-if="showTip">选择时间</span>
				<el-tooltip
					v-if="showTip"
					class="item"
					effect="dark"
					content="因数据计算量较大，为保证数据稳定，自定义时间最长选择1个月"
					placement="top"
				>
					<i class="el-icon-question blue"></i>
				</el-tooltip>
				<el-date-picker
					v-model="text"
					@change="change"
					type="daterange"
					:picker-options="pickerOptions"
					range-separator="-"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd"
					:clearable="clearable"
				>
				</el-date-picker>
			</div>
		</div>
	</div>
</template>

<script>
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import formStore from '@/mixins/formStore.js';
import { getDateRegion } from '@/common/util.js';
import { getWeekTime } from '@/utils/index.js';

export default {
	name: 'ig-daterange',
	components: {
		skydropdownSelect,
	},
	mixins: [formStore],
	props: {
		options: Array,
		value: {
			required: false,
			// default: 1, //过去7天
		},
		showTip: {
			default: true,
		},
		disabledDate: {
			default: false,
		},
		isOld: Boolean,
		initType: String,
		clearable: {
			default: true,
		},
	},
	computed: {},
	watch: {
		value: {
			handler(val) {
				this.text = val;
			},
			immediate: true,
		},
		initType: {
			handler(val) {
				this.dateRanges = getDateRegion(val);
			},
			immediate: true,
		},
	},
	data() {
		return {
			text: '',
			pickerOptions: {
				// 快捷方式
				shortcuts: [
					{
						text: '昨天',
						onClick(picker) {
							let date = getDateRegion('DAY', 'YYYY-MM-DD', '&').split('&');
							let start = date[0];
							let end = date[1];
							picker.$emit('pick', [start, end]);
						},
					},
					{
						text: '上周',
						onClick(picker) {
							let start = getWeekTime('start');
							let end = getWeekTime('end');
							picker.$emit('pick', [start, end]);
						},
					},
					{
						text: '过去7天',
						onClick(picker) {
							let date = getDateRegion('DAYS_7', 'YYYY-MM-DD', '&').split('&');
							let start = date[0];
							let end = date[1];
							picker.$emit('pick', [start, end]);
						},
					},
					{
						text: '过去30天',
						onClick(picker) {
							let date = getDateRegion('DAYS_30', 'YYYY-MM-DD', '&').split('&');
							let start = date[0];
							let end = date[1];
							picker.$emit('pick', [start, end]);
						},
					},
				],
				disabledDate: time => {
					let max = new Date(getDateRegion('DAYS_30', 'YYYY-MM-DD', '&').split('&')[0]).getTime();
					return !this.disabledDate
						? time.getTime() > Date.now()
						: time.getTime() > Date.now() || time.getTime() <= max;
				},
			},
			dateRanges: '',
		};
	},
	methods: {
		change(val) {
			this.$emit('change', val);
		},
		changeSelect(val) {
			this.selfData = val;
			this.dateRanges = getDateRegion(this.options[val].name);
			this.$emit('change', this.options[val].name, val);
		},
	},
	mounted() {
		if (!this.initType) this.dateRanges = getDateRegion('DAYS_7');
	},
};
</script>

<style lang="scss" scoped>
@import '@/client/styles/variables.scss';

.ig-daterange {
	display: flex;
	.date-dropdown {
		margin-right: 20px;
	}
	.date-range {
		font-size: $fontSize_16;
		color: $fontColor;
		font-weight: 400;
	}
}
</style>
<style>
.ig-daterange .date-dropdown .el-dropdown-link {
	color: #5aa0ff;
	font-size: 16px;
	font-weight: 400;
	line-height: 16px;
}
</style>
